/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Toastdescauth3Inputs */

const he_ratelimit_toastdescauth3 = /** @type {(inputs: Ratelimit_Toastdescauth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יותר מדי בקשות. המתן רגע לפני טעינה נוספת.`)
};

const en_ratelimit_toastdescauth3 = /** @type {(inputs: Ratelimit_Toastdescauth3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Please wait a moment before loading more.`)
};

/**
* | output |
* | --- |
* | "Too many requests. Please wait a moment before loading more." |
*
* @param {Ratelimit_Toastdescauth3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_toastdescauth3 = /** @type {((inputs?: Ratelimit_Toastdescauth3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Toastdescauth3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_toastdescauth3(inputs)
	return en_ratelimit_toastdescauth3(inputs)
});
export { ratelimit_toastdescauth3 as "rateLimit_toastDescAuth" }